import { render, staticRenderFns } from "./CoozzyUsersIcon.vue?vue&type=template&id=a0b5c19c&scoped=true"
import script from "./CoozzyUsersIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyUsersIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyUsersIcon.vue?vue&type=style&index=0&id=a0b5c19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b5c19c",
  null
  
)

export default component.exports